var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916707 19.1681C0.410424 19.1681 0 18.7576 0 18.2513V1.75061C0 1.24433 0.410424 0.833904 0.916707 0.833904H13.7506C14.2569 0.833904 14.6673 1.24433 14.6673 1.75061V4.50073H12.8339V2.66732H1.83341V17.3346H12.8339V15.5012H14.6673V18.2513C14.6673 18.7576 14.2569 19.1681 13.7506 19.1681H0.916707ZM12.8339 13.6678V10.9177H6.41695V9.08427H12.8339V6.33415L17.4174 10.001L12.8339 13.6678Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.916707 19.1681C0.410424 19.1681 0 18.7576 0 18.2513V1.75061C0 1.24433 0.410424 0.833904 0.916707 0.833904H13.7506C14.2569 0.833904 14.6673 1.24433 14.6673 1.75061V4.50073H12.8339V2.66732H1.83341V17.3346H12.8339V15.5012H14.6673V18.2513C14.6673 18.7576 14.2569 19.1681 13.7506 19.1681H0.916707ZM12.8339 13.6678V10.9177H6.41695V9.08427H12.8339V6.33415L17.4174 10.001L12.8339 13.6678Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2c79c0172cc9ac20d18784b98c78d6d5.svg";
export { ForwardRef as ReactComponent };